import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { hydrate as hydrateQueryCache } from "@tanstack/react-query";
import { AppProviders, AppRoutes, createQueryClient } from "./AppInner";
import "./index.css";

const container = document.getElementById("root")!;

// Compatibilite avec les anciennes coquilles : les metadonnees de la route
// restent sous la responsabilite de Helmet.
document.querySelectorAll("[data-shell-meta]").forEach((el) => el.remove());

const queryClient = createQueryClient();

// Le pre-rendu depose le cache serialise ici : on le rejoue avant le premier
// rendu, sinon React Query refetche et l'ecran clignote.
const dehydratedState = (window as unknown as { __RQ_STATE__?: unknown }).__RQ_STATE__;
if (dehydratedState) {
  hydrateQueryCache(queryClient, dehydratedState);
}

const app = (
  <AppProviders client={queryClient}>
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  </AppProviders>
);

// Page pre-rendue : on hydrate. Page vide (dev, route non pre-rendue) : on monte.
if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}

// Emettre un event quand React a fini de render (pour le pre-rendu SEO)
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    window.dispatchEvent(new Event("app-rendered"));
  });
});
